import React from 'react';

import s from './ButtonLoader.module.scss';

function ButtonLoader() {
  return <span className={s.buttonLoader} aria-hidden />;
}

export default ButtonLoader;
